import React, { useState } from 'react';
import styled from 'styled-components/macro';
import { theme } from 'lib/style';
import bgImageDesktopPhaseOneNew from 'assets/images/freemiumOnboarding/bgOnboardingRecord.png';
import { useAuth } from 'lib/context';
import { DocumentHead } from 'lib/components';

import { useLogoUrl } from 'lib/hooks/useLogoUrl';
import { Flex } from 'lib/components/styles/layout';

import { RecordFreemiumCam } from 'app/pages/onboardingFreemium/record/RecordFreemiumCam';

type ColWrapperProps = {
  marginTop?: string;
  padding: string;
};
const MainDiv = styled.div`
  background-image: url(${bgImageDesktopPhaseOneNew});
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: bottom;
  height: 100vh;
  ${theme.mediaQueryMaxWidth.mb} {
    background-image: none;
  }
`;
const MainWrapper = styled.div`
  display: grid;
  width: 100%;
  margin: auto;
  box-sizing: border-box;
  grid-auto-columns: 1fr;
  grid-auto-flow: column;
  ${theme.mediaQueryMaxWidth.mb} {
    grid-auto-flow: row;
  }
`;
const ColWrapper = styled.div<ColWrapperProps>`
  padding: ${props => props.padding};
  font-style: normal;
  min-width: 300px;
  margin-top: ${props => props.marginTop};
`;

const MainHeading = styled.h2`
  font-weight: 500;
  font-size: 32px;
  line-height: 48px;
  color: ${theme.palette.covideoBlue100};
`;
const Heading = styled.h2`
  margin-top: 4px;
  font-style: normal;
  font-weight: 700;
  font-size: 32px;
  line-height: 48px;
  color: ${theme.palette.covideoBlue100};
`;
const Text = styled.div`
  width: 518px;
  height: 84px;
  display: flex;
  flex-direction: column;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  font-feature-settings:
    'tnum' on,
    'lnum' on;
  color: ${theme.palette.covideoBlue100};
  margin-top: 40px;
  span {
    margin-top: 10px;
  }
`;

const Image = styled.img`
  height: 40px;
  width: 200px;
  margin-left: 112px;
  top: 48px;
  cursor: pointer;
  margin-top: 48px;
`;

export const FreemiumOnboardingRecordPage = () => {
  const { userData } = useAuth();
  const { logoUrl } = useLogoUrl('dark');
  const [showGetStartedGuide, setShowGetStartedGuide] = useState(false);

  const handleShowGetStartedGuide = () => {
    setShowGetStartedGuide(true);
  };

  return (
    <>
      <DocumentHead title='Onboarding' />
      <MainDiv>
        <Image src={logoUrl} />
        <MainWrapper>
          {!showGetStartedGuide && (
            <ColWrapper marginTop={'26px'} padding={'40px 0 0 112px'}>
              <MainHeading>Well done, {userData?.firstName}!</MainHeading>
              <Heading>
                Record your first video, <span>it's easy!</span>
              </Heading>
              <Text>
                It's easy to get started. We'll walk you through how to use our
                recording tool.
                <span>
                  Don't worry about getting it perfect on the first try! Covideo
                  stores your videos securely in your library until you're ready
                  to share with your contacts.
                </span>
              </Text>
            </ColWrapper>
          )}
          <Flex
            padding={'40px 0 0 0'}
            justifyContent='center'
            alignItems='center'
            style={{ width: 600, margin: '0 auto' }}
          >
            <RecordFreemiumCam
              handleShowGetStartedGuide={handleShowGetStartedGuide}
            />
          </Flex>
        </MainWrapper>
      </MainDiv>
    </>
  );
};
